import * as React from "react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { DidNotAttendButton } from "../../clinicalNotes/components/DidNotAttendButton";

interface Props {
    customerId: string;
    ohCaseId: string;
    readonly: boolean;
    task: TaskModel;
}

export const BbvReportDidNotAttendButton: React.FunctionComponent<Props> = (props: Props) => {

    const { customerId, ohCaseId, readonly, task } = props;

    if (readonly) {
        return null;
    }

    return <DidNotAttendButton customerId={customerId} ohCaseId={ohCaseId} task={task} />;
};
